export const calculateExpiresTask = (task) => {
  const endDate = task?.endDate;
  if (!endDate) {
    return 0;
  }
  // Append Z to date if not present so that it is parsed as UTC
  return Date.parse(endDate.endsWith('Z') ? endDate : endDate + 'Z');
};

export function parseTask(json) {
  return {
    taskId: json.idHit,
    formId: json.idForm,
    projectId: json.idProject,
    projectTitle: json.projectTitle,
    columns: (json?.columns || []).map((column) => ({
      name: column.name,
      data: column.data,
      type: column.type,
    })),
    answers: Object.keys(json?.answers || {}).reduce(
      (answers, keyAnswer) => ({
        ...answers,
        [keyAnswer]: json?.answers[keyAnswer],
      }),
      {},
    ),
    supplierId: json.user.idUser,
    answer: json?.inputJson,
    isReview: json.isReview,
    expiresAt: calculateExpiresTask(json),
  };
}
